import React from 'react'

import {Posts, Form } from '../../components'

import {Grid, Modal, Button} from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


const Home = () => {
   const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Grid
     container justify='space-between' 
     alignItems='center'
      spacing={2}>
    <Grid item xs={12} sm={12}>
      <Posts handleOpen={handleOpen} />
    </Grid>
     <Button 
     onClick={handleOpen}
      variant="contained"
     sx={{position: 'fixed', right: 0, top: '50%', bottom:'50%', height:'max-content', width:'auto', zIndex: 100}}
     >
       <AddCircleOutlineIcon size="large" />
       </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={{
         position: 'absolute',
         overflow: 'hidden',
         top: '50%',
         left: '50%',
         borderRadius: '1rem',
         transform: 'translate(-50%, -50%)',
        border: '2px solid blue',
        boxShadow: 24,}}>
 <Form handleClose={handleClose}/>
        </div>
     
    </Modal>
  </Grid>
  )
}

export default Home